import firebase from 'firebase';
import { Investor } from 'procura-shared';
import { investorsQuery } from 'procura-shared/src/queries';
import { useEffect, useState } from 'react';

export const useInvestmentInvestors = (investorIds: string[]): [Investor[], boolean] => {
  const [loading, setLoading] = useState<boolean>();
  const [investors, setInvestors] = useState<Investor[]>([]);

  useEffect(() => {
    setLoading(true);

    const run = async () => {
      try {
        const response = await batchInvestors(investorIds);
        setInvestors(response);
      } catch (error) {
        throw error;
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [investorIds]);

  const batchInvestors = async (queryItems: any[]) => {
    if (!queryItems || !queryItems.length) return [];

    const batches = [];

    while (queryItems.length) {
      const batch = queryItems.splice(0, 10);

      batches.push(
        investorsQuery()
          .where(firebase.firestore.FieldPath.documentId(), 'in', [...batch])
          .get()
          .then((results) =>
            results.docs.map((result) => ({
              id: result.id,
              ...result.data(),
            }))
          )
      );
    }

    return Promise.all(batches).then((content) => content.flat());
  };

  return [investors, loading];
};
